import { NgModule } from '@angular/core';

import { CapitalizePipe } from './capitalize.pipe';
import { DateFormatPipe } from './dateFormat.pipe';
import { FilterPipe } from './filterString.pipe';
import { GroupByPipe } from './groupByPipe.pipe';
import { KeysPipe } from './keyPipe.pipe';
import { phoneFormatPipe } from './phoneFormat.pipe';
import { FiveDigitRandomNumberPipe } from './randomNumber.pipe';
import { TimeFormat24Pipe } from './timeFormat24.pipe';
import { ColorsKeysPipe } from './objectKey.pipe';
import { YoutubePipe } from './yTubeUrl.pipe';
import { SkuKeyPipe } from './skuType.pipe';
import { GroupPipe } from './listGroupArray.pipe';
import { MatchedKeyPipe } from './keyFromArray.pipe';
import { AcceptStatusPipe } from './listApproved.pipe';
import { FirstCharacterUpperCase } from './capitalizeUpperCase.pipe'
import { FilterArrayPipe } from './filter.pipe';
import { FilterExactArrayPipe } from './filterExactMatch.pipe';
import { FirstLinePipe } from './firstLine.pipe';
import { UtcToLocalPipe } from './utcToLocal.pipe';
import { ProductTypePipe } from './productType.pipe';
import { IsEmptyPipe } from './isEmpty.pipe';
import { RemovePipe } from './removeChar.pipe';
import { SafePipe } from './safe.pipe';
import { UTCsecondsPipe } from './utcSeconds.pipe';

@NgModule({
    declarations: [
        CapitalizePipe,
        DateFormatPipe,
        FilterPipe,
        GroupByPipe,
        KeysPipe,
        phoneFormatPipe,
        FiveDigitRandomNumberPipe,
        TimeFormat24Pipe,
        ColorsKeysPipe,
        YoutubePipe,
        SkuKeyPipe,
        GroupPipe,
        MatchedKeyPipe,
        AcceptStatusPipe,
        FirstCharacterUpperCase,
        FilterArrayPipe,
        FilterExactArrayPipe,
        FirstLinePipe,
        UtcToLocalPipe,
        ProductTypePipe,
        IsEmptyPipe,
        RemovePipe,
        SafePipe,
        UTCsecondsPipe

    ],
    imports: [],
    exports: [
        CapitalizePipe,
        DateFormatPipe,
        FilterPipe,
        GroupByPipe,
        KeysPipe,
        phoneFormatPipe,
        FiveDigitRandomNumberPipe,
        TimeFormat24Pipe,
        ColorsKeysPipe,
        YoutubePipe,
        SkuKeyPipe,
        GroupPipe,
        MatchedKeyPipe,
        AcceptStatusPipe,
        FirstCharacterUpperCase,
        FilterArrayPipe,
        FilterExactArrayPipe,
        FirstLinePipe,
        UtcToLocalPipe,
        ProductTypePipe,
        IsEmptyPipe,
        RemovePipe,
        SafePipe,
        UTCsecondsPipe
    ]
})

export class PipesModule {

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/pipes.module.ts